import { BASE_URL } from "config";
import * as baseApi from "./_base";

export const endpoints = {
    list: `${BASE_URL}/api/v1/profile/`,
    detail: (id) => `${BASE_URL}/api/v1/profile/${id}/`,
};

export const profileLoad = (token, payload) => baseApi.ListLoad(endpoints.list, token, payload);
export const profileDetailLoad = (token, { id }) => baseApi.DetailLoad(endpoints.detail, token, { id });
export const profileUpdate = (token, data) => baseApi.Update(endpoints.list, endpoints.detail, token, data);
export const profileDelete = (token, { id }) => baseApi.Delete(endpoints.detail, token, { id });
